export default "__VITE_ASSET__DnViT0dq__"